import { IconButton } from '@act/storybook';
import { Tooltip } from '@mui/material';
import type { ReactNode } from 'react';

export interface ReportIconActionButtonProps {
  /** Accessible label and tooltip text. */
  label: string;
  /** Datadog tracking name for the action. */
  trackingName: string;
  /** Click handler for the action. */
  onClick: () => void;
  /** When true, the button is not interactive. */
  disabled?: boolean;
  /** Phosphor icon element to render inside the button. */
  children: ReactNode;
}

/**
 * Icon-only report action with tooltip and tracking.
 * @param props - Label, handler, and icon content.
 */
const ReportIconActionButton = ({
  label,
  trackingName,
  onClick,
  disabled = false,
  children,
}: ReportIconActionButtonProps) => (
  <Tooltip title={label}>
    <span>
      <IconButton
        aria-label={label}
        trackingName={trackingName}
        onClick={onClick}
        disabled={disabled}
        size="small"
      >
        {children}
      </IconButton>
    </span>
  </Tooltip>
);

export default ReportIconActionButton;
